import React from 'react';

interface LogInIconProps {
  className?: string;
}

export const LogInIcon = ({ className = '' }: LogInIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    className={className}
  >
    <path
      d="M14.3179 1.5C14.9146 1.5 15.4867 1.73722 15.9087 2.15918C16.3306 2.58114 16.5679 3.15326 16.5679 3.75V14.25C16.5679 14.8467 16.3306 15.4189 15.9087 15.8408C15.4867 16.2628 14.9146 16.5 14.3179 16.5H11.3179C10.9037 16.5 10.5679 16.1642 10.5679 15.75C10.5679 15.3358 10.9037 15 11.3179 15H14.3179C14.5168 15 14.7075 14.9209 14.8481 14.7803C14.9888 14.6396 15.0679 14.4489 15.0679 14.25V3.75C15.0679 3.55109 14.9888 3.36038 14.8481 3.21973C14.7075 3.07907 14.5168 3 14.3179 3H11.3179C10.9037 3 10.5679 2.66421 10.5679 2.25C10.5679 1.83579 10.9037 1.5 11.3179 1.5H14.3179ZM7.0376 4.71973C7.33049 4.42683 7.80525 4.42683 8.09814 4.71973L11.8481 8.46973C11.8965 8.51812 11.9339 8.57319 11.9663 8.62988C11.9818 8.65703 11.9982 8.68375 12.0103 8.71289C12.031 8.76289 12.0457 8.81459 12.0552 8.86719C12.0629 8.91035 12.0679 8.95462 12.0679 9C12.0679 9.04505 12.0628 9.08897 12.0552 9.13184C12.0458 9.18447 12.0309 9.23609 12.0103 9.28613C11.9982 9.3153 11.9818 9.34196 11.9663 9.36914C11.9338 9.42611 11.8968 9.48167 11.8481 9.53027L8.09814 13.2803C7.80525 13.5732 7.33049 13.5732 7.0376 13.2803C6.7447 12.9874 6.7447 12.5126 7.0376 12.2197L9.50732 9.75H2.31787C1.90366 9.75 1.56787 9.41421 1.56787 9C1.56787 8.58579 1.90366 8.25 2.31787 8.25H9.50732L7.0376 5.78027C6.7447 5.48738 6.7447 5.01262 7.0376 4.71973Z"
      fill="var(--color-text-primary-alt)"
    />
  </svg>
);
